import { Component, inject, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppliedBranchDetails, BankInDetails } from '../apply-asset-request/apply-asset-request.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { GlobalCustomer } from 'src/model/globalCustomer.model';
import { Company } from 'src/model/company.model';
import { AssetSheetRequestService } from 'src/services/asset-sheet-request.service';
import { Enums } from 'src/app/Shared/enums';
import { DatePipe } from '@angular/common';
import { SheetDetails } from 'src/model/assetSheetRequestDetails.model';
import { MessageClipboardComponent } from 'src/app/MessageClipboard/message-clipboard/message-clipboard.component';
import { CompanyService } from 'src/services/company.service';
import { FinanceAccount } from 'src/model/financeAccount.model';
import { BusinessService } from 'src/services/business.service';
import { FinanceAccountService } from 'src/services/finance-account.service';
import { ThisWeekExpressionDescription } from 'igniteui-angular-core';

@Component({
	selector: 'app-asset-request-summary',
	standalone: false,
	templateUrl: './asset-request-summary.component.html',
	styleUrl: './asset-request-summary.component.scss',
	providers: [DatePipe]
})
export class AssetRequestSummaryComponent implements OnInit {
	protected disabledSubmit = false;
	protected isDistributionCollapse = false;
	protected kerjaContraList: AppliedBranchDetails[] = new Array();
	protected finalDistribution: any[] = new Array();
	protected uuid: string;
	protected sharedService = inject(SharedService);
	protected sheetRequestService = inject(AssetSheetRequestService);
	protected activeModal = inject(NgbActiveModal);
	protected enums = inject(Enums);
	protected datepipe = inject(DatePipe);
	protected companyService = inject(CompanyService);
	protected businessService = inject(BusinessService);
	protected financeAccountService = inject(FinanceAccountService);

	//COMMON
	@Input() reason: string;
	@Input() loggedInCompany: Company;
	@Input() selectedApplyOpt: string;
	@Input() amount: number;
	@Input() type: string;

	@Input() bankInDetailsList: BankInDetails[] = [];
	@Input() appliedBranchList: AppliedBranchDetails[] = [];
	@Input() formJCompany: string; //change
	@Input() defaultFinanceAccount: FinanceAccount;
	@Input() selectedCustomer: GlobalCustomer;

	//TICKET
	@Input() includeKerja = false;
	@Input() ticketList = new Array();

	//EXPENSE
	@Input() cashInOffice: number;
	@Input() lastestCheckIn: Date;

	//CONTRA
	@Input() contraApplyBranches: AppliedBranchDetails[] = [];
	@Input() contraReturnBranches: AppliedBranchDetails[] = [];

	protected loggedInUser: string;

	ngOnInit() {
		console.log(this.lastestCheckIn);
		console.log(this.cashInOffice);
		if (this.appliedBranchList.length == 0 && this.amount > 0)
			this.appliedBranchList.push({
				appliedBranch: new Company(this.loggedInCompany.ID, undefined, undefined, this.loggedInCompany.CompanyCode),
				amount: this.amount
			});

		this.loggedInUser = sessionStorage.getItem('username');

		this.processContraAndDistribute();
	}

	processKerjaOverlap(branches: AppliedBranchDetails[], totalLimit: number): AppliedBranchDetails[] {
		let carry = 0;
		let totalUsed = 0;

		return branches.map(b => {
			const input = b.kerja ?? 0;

			let requested = input + carry;

			// enforce total limit
			// if (totalUsed + requested > totalLimit) {
			//   requested = totalLimit - totalUsed;
			// }

			//to be assigned into object
			const used = Math.min(b.amount, requested);
			const overflow = Math.max(0, requested - b.amount);
			const remainingAmount = b.amount - used;

			const contraApply = carry ?? 0;

			totalUsed += used;
			carry = overflow;

			if (contraApply > 0) {
				let ca = { appliedBranch: b.appliedBranch, amount: contraApply };
				this.contraApplyBranches.push(ca);
			} else if (overflow > 0) {
				let ca = { appliedBranch: b.appliedBranch, amount: overflow };
				this.contraReturnBranches.push(ca);
			}

			return {
				...b,
				carryAmount: contraApply, //contra apply
				remainingAmount: remainingAmount, //bank in amount
				overflow: overflow //contra return
			};
		});
	}
	getTotal(list: any[], key: string): number {
		return list.reduce((sum, acc) => {
			return sum + (acc[key] ?? 0);
		}, 0);
	}

	processContraAndDistribute() {
		if (this.includeKerja) {
			const total = this.getTotal(this.appliedBranchList, 'amount');
			this.kerjaContraList = this.processKerjaOverlap(this.appliedBranchList, total);
			this.distribute(this.kerjaContraList);
		} else this.distribute(this.appliedBranchList);
	}

	mapToBalances(branches: AppliedBranchDetails[]) {
		return branches.map(b => ({
			appliedBranch: b.appliedBranch,
			amount: b.remainingAmount ?? 0
		}));
	}

	distribute(appliedBranchList: AppliedBranchDetails[]) {
		this.finalDistribution = [];
		//TEST DATA
		// this.appliedBranchList = [{ appliedBranch: new Company(undefined undefined undefined "A") distributedAmount: 12000 } { appliedBranch: new Company(undefined undefined undefined "B") distributedAmount: 18000 }]
		// this.bankInDetailsList = [{ bankInAccount: new CustomerAccount(undefined "hhahaha" "11111" "11") amount: 15000 } { bankInAccount: new CustomerAccount(undefined "hhahaha" "22222" "22") amount: 15000 }]

		//const branchBalances = this.appliedBranchList.map(b => ({ ...b }));

		const branchBalances = this.includeKerja ? this.mapToBalances(appliedBranchList) : this.appliedBranchList.map(b => ({ ...b }));

		for (const bank of this.bankInDetailsList) {
			let remaining = bank.amount;

			const allocations = [];
			for (const branch of branchBalances) {
				if (remaining === 0) break;

				if (branch.amount === 0) continue;

				const used = Math.min(branch.amount, remaining);
				allocations.push({
					branch: branch.appliedBranch,
					amount: used
				});

				branch.amount -= used;
				remaining -= used;
			}

			this.finalDistribution.push({
				bank: bank.bankInAccount,
				total: bank.amount,
				distributed: allocations
			});
		}
	}

	async buildRequestList() {
		var sheetRequestList = [];

		const uuidV4 = window.crypto.randomUUID();
		this.uuid = uuidV4.split('-')[0] + '-' + uuidV4.split('-')[1];

		const now = new Date();
		const timestamp = this.datepipe.transform(now, 'yyyy-MM-dd HH:mm:ss', '+0800');
		const ticketString = this.ticketList.length > 0 ? this.ticketList.map(m => m.ids).join(' | ') : '';
		const santizedReason = this.reason.replace(';', ',');

		for (let i = 0; i < this.finalDistribution.length; i++) {
			for (let j = 0; j < this.finalDistribution[i].distributed.length; j++) {
				let mbb = 0;
				let others = 0;
				if (j == 0) {
					if (this.finalDistribution[i].bank.Bank == 'MAYBANK') mbb += this.finalDistribution[i].total;
					else others = this.finalDistribution[i].total;
				}

				// in account details need to indicate if this account belongs to guarantor
				let isGuarantorAcct = this.finalDistribution[i].bank.ContactId == undefined ? '' : '(G)';

				let acctDetails =
					isGuarantorAcct + this.finalDistribution[i].bank.HolderName + '(' + this.finalDistribution[i].bank.Bank + ' ' + this.finalDistribution[i].bank.AccountNumber + ')';

				let cashInOfficeDetails =
					this.selectedApplyOpt == 'EXPENSES' ? 'RM ' + this.sharedService.roundTo2Dec(this.cashInOffice) + '@' + this.datepipe.transform(this.lastestCheckIn, 'dd-MM-yyyy') : '';

				let sd = new SheetDetails();
				sd.Type = this.selectedApplyOpt;
				sd.FormJCompany = this.formJCompany;
				sd.MbbMaster = mbb || '';
				sd.OtherBankMaster = others || '';

				var sqlInfo = await this.companyService.getCompanySQLInfo(this.finalDistribution[i].distributed[j].branch.ID);

				sd.BranchName = this.finalDistribution[i].distributed[j].branch.CompanyCode + '@' + sqlInfo.GLCode;
				sd.BankName = this.defaultFinanceAccount.Description + '@' + this.defaultFinanceAccount.Code;
				sd.AccountDetails = acctDetails;
				sd.CustomerName = this.selectedCustomer?.Name || '';
				sd.LineAmount = this.finalDistribution[i].distributed[j].amount;
				sd.CashInOffice = cashInOfficeDetails;
				const appendTicketAsRemark = ticketString == '' ? '' : `(${ticketString})`;
				sd.Remark = santizedReason + appendTicketAsRemark;
				sd.Ticket = ticketString;
				sd.Timestamp = timestamp;
				sd.Uuid = this.uuid;
				sd.RequestedBy = this.loggedInUser;

				// if (
				//   this.selectedApplyOpt == "EXPENSES" ||
				//   this.selectedApplyOpt == "TICKET"
				// )

				//START 6/6/2026 - ALL APPLY AUTO DONE
				sd.Proceed = 'DONE'; //HARD CODED

				//convert all class properties into value in array
				//in this case property order is important!!
				const s = Object.values(sd);

				sheetRequestList.push(s);
			}
		}

		for (const [index, e] of this.contraApplyBranches.entries()) {
			let acctDetails = 'CONTRA ACCT';
			let cashInOfficeDetails = '';

			let mbbMaster = index == 0 ? this.sharedService.getListTotalWithKey(this.contraApplyBranches, 'amount') : '';
			let sd = new SheetDetails();
			sd.Type = 'CONTRA'; //hard coded
			sd.BankName = 'CONTRA MANAGER'; //hard coded
			sd.FormJCompany = this.formJCompany;
			sd.MbbMaster = mbbMaster;
			sd.OtherBankMaster = '';

			var sqlInfo = await this.companyService.getCompanySQLInfo(e.appliedBranch.ID);

			sd.BranchName = e.appliedBranch.CompanyCode + '@' + sqlInfo.GLCode;

			sd.AccountDetails = acctDetails;
			sd.CustomerName = '';
			sd.LineAmount = e.amount;
			sd.CashInOffice = cashInOfficeDetails;
			sd.Remark = santizedReason;
			sd.Ticket = ticketString;
			sd.Timestamp = timestamp;
			sd.Uuid = this.uuid;
			sd.RequestedBy = this.loggedInUser;
			sd.Checker = 'DONE'; //HARD CODED;

			//convert all class properties into value in array
			//in this case property order is important!!
			const s = Object.values(sd);
			sheetRequestList.push(s);
		}

		for (const [index, e] of this.contraReturnBranches.entries()) {
			let acctDetails = 'CONTRA ACCT';
			let cashInOfficeDetails = '';

			let mbbMaster = index == 0 ? this.sharedService.getListTotalWithKey(this.contraApplyBranches, 'amount') : '';

			let sd = new SheetDetails();
			sd.Type = 'RETURN'; //hard coded
			sd.BankName = 'CONTRA MANAGER'; //hard coded
			sd.FormJCompany = this.formJCompany;
			sd.MbbMaster = mbbMaster;
			sd.OtherBankMaster = '';

			var sqlInfo = await this.companyService.getCompanySQLInfo(e.appliedBranch.ID);
			sd.BranchName = e.appliedBranch.CompanyCode + '@' + sqlInfo.GLCode;
			sd.AccountDetails = acctDetails;
			sd.CustomerName = '';
			sd.LineAmount = e.amount;
			sd.CashInOffice = cashInOfficeDetails;
			sd.Remark = santizedReason;
			sd.Ticket = ticketString;
			sd.Timestamp = timestamp;
			sd.Uuid = this.uuid;
			sd.RequestedBy = this.loggedInUser;
			sd.Checker = 'DONE'; //HARD CODED;

			//convert all class properties into value in array
			//in this case property order is important!!
			const s = Object.values(sd);
			sheetRequestList.push(s);
		}

		return sheetRequestList;
	}

	async sendRequestAndShowMessage() {
		this.disabledSubmit = true;
		const result = await this.sheetRequestService.postAsstSheetRequest(await this.buildRequestList());
		if (result != undefined) {
			const finalMessage = this.constructMessage();
			const modalref = this.sharedService.openModal(MessageClipboardComponent, 'largeModal');
			modalref.componentInstance.value = finalMessage;
			modalref.componentInstance.isModal = true;
			modalref.componentInstance.modalTitle = `Asset Request Message - ${this.selectedApplyOpt}`;

			this.activeModal.close();
		}
	}

	constructMessage() {
		var bankDetails = this.finalDistribution.length > 0 ? '\n*BANK IN TO 💸*\n' : '';
		var distributionDetails = this.appliedBranchList.length > 0 ? '\n*WHO APPLIED 💰*\n' : '';
		var contraDetails = '';
		var ticketDetails = '';
		var cashInOfficeDetails =
			this.selectedApplyOpt == 'EXPENSES' ? 'RM ' + this.sharedService.roundTo2Dec(this.cashInOffice) + '@' + this.datepipe.transform(this.lastestCheckIn, 'dd-MM-yyyy') : '';
		var remark = this.selectedApplyOpt == 'EXPENSES' ? 'EXPENSES' : this.reason;

		ticketDetails += this.ticketList.length > 0 ? '*🎫 TICKET*=' + this.ticketList.map(m => m.ids).join(' | ') : '';

		this.finalDistribution.forEach(d => {
			bankDetails += d.bank.HolderName + '\n' + d.bank.Bank + '(' + d.bank.AccountNumber + ') = RM ' + this.sharedService.roundTo2Dec(d.total) + '\n--------------------\n';
		});

		if (this.includeKerja) this.appliedBranchList = [...this.kerjaContraList];
		this.appliedBranchList.forEach(b => {
			var contraReturn = b.overflow ?? 0;
			var contraApply = b.carryAmount ?? 0;

			let amount = this.includeKerja ? b.remainingAmount + b.carryAmount : b.amount;
			distributionDetails += amount > 0 ? b.appliedBranch.CompanyCode + '= RM ' + this.sharedService.roundTo2Dec(amount) + '\n' : '';
			distributionDetails += contraApply > 0 ? '(CONTRA RM' + contraApply + ' + ' + ' TRANSFER RM ' + b.remainingAmount + ')\n' : '';

			contraDetails += contraReturn > 0 ? 'RETURN =' + b.appliedBranch.CompanyCode + ':  RM ' + this.sharedService.roundTo2Dec(contraReturn) + '\n' : '';
			contraDetails += contraApply > 0 ? 'APPLY =' + b.appliedBranch.CompanyCode + ': RM ' + this.sharedService.roundTo2Dec(contraApply) + '\n' : '';
		});

		if (this.kerjaContraList.length == 0 && this.contraApplyBranches.length > 0 && this.contraReturnBranches.length > 0) {
			contraDetails += '*CONTRA 💱*\n';

			this.contraApplyBranches.forEach(ca => {
				contraDetails += 'APPLY =' + ca.appliedBranch.CompanyCode + ': RM ' + this.sharedService.roundTo2Dec(ca.amount) + '\n';
			});

			this.contraReturnBranches.forEach(cr => {
				contraDetails += 'RETURN =' + cr.appliedBranch.CompanyCode + ':  RM ' + this.sharedService.roundTo2Dec(cr.amount) + '\n';
			});
		}
		return `*# ${this.uuid} - ${this.selectedApplyOpt}*${distributionDetails}${bankDetails}${contraDetails}${ticketDetails}\nCASH IN OFFICE:${cashInOfficeDetails}*\nREMARK: ${remark}*`;
	}
	reset() {
		this.activeModal.close();
	}

	submit() {}
}
